/**
 * Shared bodyScrollLockOptions for the `body-scroll-lock` library
 * (`assets/body-scroll-lock.js`). Used by Drawer, Popup, Header, and friends
 * when locking the page scroll.
 *
 * Loaded as ES module via importmap alias `@theme/body-scroll-lock-options`.
 */

export const bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};
